import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ScrollText } from "lucide-react";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setLogs(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-5" data-testid="audit-page">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">Audit Log</h1>
        <p className="text-sm text-slate-500">CROA-compliant record of who viewed, sent, and changed what.</p>
      </div>
      <div className="rounded-lg border border-slate-200 bg-white" data-testid="audit-log-feed">
        <div className="px-4 py-2.5 border-b border-slate-100 flex items-center gap-2">
          <ScrollText className="h-4 w-4 text-slate-400" />
          <span className="text-xs font-mono uppercase tracking-[0.18em] text-slate-500">{logs.length} events</span>
        </div>
        <div className="divide-y divide-slate-100 max-h-[70vh] overflow-y-auto">
          {logs.map((a) => (
            <div key={a.id} className="px-4 py-3 flex items-start justify-between gap-4">
              <div>
                <div className="text-sm text-slate-800">
                  <span className="font-medium">{a.actor_name}</span>{" "}
                  <span className="text-blue-700 font-medium">{a.action.replace(/_/g, " ")}</span>{" "}
                  <span className="text-slate-500">{a.entity}</span>
                </div>
                {a.detail && <div className="text-xs text-slate-400 mt-0.5">{a.detail}</div>}
              </div>
              <div className="text-xs text-slate-400 whitespace-nowrap font-mono">{new Date(a.created_at).toLocaleString()}</div>
            </div>
          ))}
          {logs.length === 0 && <div className="py-10 text-center text-sm text-slate-400">No activity yet.</div>}
        </div>
      </div>
    </div>
  );
}
